import React from 'react';
import { LTModal } from '@lambdatestincprivate/lt-components';
import styles from './header.module.css';

/**
 * kaneai DatasetModal port ("Dataset Values": # + one column per
 * parameter, the run's row highlighted). kaneai fetches the whole dataset
 * version from its API; a pack carries only the row this run used, so the
 * table shows that row — the name, version and row number say which.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DatasetValuesModal(_ref) {
  var _dataset$rowIndex;
  var dataset = _ref.dataset,
    values = _ref.values,
    onClose = _ref.onClose;
  var subtitle = [dataset.name, dataset.rowIndex !== null ? "Row ".concat(dataset.rowIndex) : null].filter(Boolean).join(' · ');
  return /*#__PURE__*/_jsx(LTModal, {
    isOpen: true,
    ariaLabel: "Dataset Values",
    onClose: onClose,
    customHeaderComponent: /*#__PURE__*/_jsxs("div", {
      className: styles.dsHeader,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.dsTitle,
        children: "Dataset Values"
      }), subtitle && /*#__PURE__*/_jsx("span", {
        className: styles.dsSubtitle,
        children: subtitle
      })]
    }),
    extraStyle: {
      width: '640px',
      maxWidth: '92vw',
      maxHeight: '86vh',
      overflow: 'hidden',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif"
    },
    children: /*#__PURE__*/_jsx("div", {
      className: styles.dsBody,
      children: dataset.columns.length === 0 ? /*#__PURE__*/_jsx("p", {
        className: styles.dsEmpty,
        children: "This pack lists no dataset columns."
      }) : /*#__PURE__*/_jsx("div", {
        className: styles.dsTableWrap,
        children: /*#__PURE__*/_jsxs("table", {
          className: styles.dsTable,
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("th", {
                scope: "col",
                className: styles.dsNumCell,
                children: "#"
              }), dataset.columns.map(function (column) {
                return /*#__PURE__*/_jsx("th", {
                  scope: "col",
                  children: column
                }, column);
              })]
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: /*#__PURE__*/_jsxs("tr", {
              className: styles.dsRowActive,
              "aria-current": "true",
              children: [/*#__PURE__*/_jsx("td", {
                className: styles.dsNumCell,
                children: (_dataset$rowIndex = dataset.rowIndex) !== null && _dataset$rowIndex !== void 0 ? _dataset$rowIndex : '—'
              }), dataset.columns.map(function (column, i) {
                var _values$i;
                return /*#__PURE__*/_jsx("td", {
                  "aria-busy": values === null,
                  children: values === null ? /*#__PURE__*/_jsx("span", {
                    className: styles.dsMissing,
                    children: "Loading\u2026"
                  }) : (_values$i = values[i]) !== null && _values$i !== void 0 ? _values$i : /*#__PURE__*/_jsx("span", {
                    className: styles.dsMissing,
                    title: "Not in this evidence pack",
                    children: "\u2014"
                  })
                }, column);
              })]
            })
          })]
        })
      })
    })
  });
}